import { useLayoutEffect, useRef, type TextareaHTMLAttributes } from 'react';

/**
 * A textarea that grows with what is typed, the way every chat app's does,
 * instead of clipping to a fixed box and scrolling inside it. It stops growing
 * at about half the screen and scrolls from there, so a long pitch never
 * pushes the send button out of reach.
 */
export default function AutoTextarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>): React.ReactElement {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Collapse first: scrollHeight never shrinks below the current height.
    el.style.height = 'auto';
    const limit = Math.max(200, Math.round(window.innerHeight * 0.5));
    el.style.height = `${Math.min(el.scrollHeight + 2, limit)}px`;
    el.style.overflowY = el.scrollHeight + 2 > limit ? 'auto' : 'hidden';
  }, [props.value]);

  return <textarea ref={ref} {...props} style={{ resize: 'none', ...props.style }} />;
}
